const styles = (theme) => ({
  root: {
    display: 'flex',
    flex: '0 0 100%',
  },
  card: {
    width: '100%',
  },
  icon: {
    color: theme.palette.custom.wellbeing,
    marginTop: '0px',
  },
  cardContent: {
    paddingTop: 0,
    paddingRight: 0,
    paddingLeft: 0,
  },
  contentContainer: {
    padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 2}px 0 ${
      theme.spacing.unit * 2
    }px`,
    [theme.breakpoints.up('md')]: {
      padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px 0 ${
        theme.spacing.unit * 3
      }px`,
      marginLeft: '85px',
    },
    '&:hover': {
      cursor: 'pointer',
    },
  },
  cardText: {
    width: '100%',
    paddingRight: theme.spacing.unit,
  },
  subtitle: {
    marginBottom: theme.spacing.unit * 2,
  },
  image: {
    width: '100%',
  },
  viewDetails: {
    '&&': {
      color: theme.palette.primary.dark,
      fontSize: '0.9375rem',
      [theme.breakpoints.up('sm')]: {
        fontSize: '1rem',
      },
      margin: `${theme.spacing.unit * 1.5}px 0 -${theme.spacing.unit * 0.5}px`,
    },
    '&:hover': {
      cursor: 'pointer',
    },
  },
  chevronIcon: {
    '&&': {
      fontSize: '2rem',
      verticalAlign: 'middle',
      margin: `0 -${theme.spacing.unit}px 0 0`,
    },
  },
  dividerTop: {
    margin: `0 ${theme.spacing.unit * 2}px 0`,
    [theme.breakpoints.up('md')]: {
      margin: `0 40px 0 110px`,
    },
  },
  divider: {
    marginTop: theme.spacing.unit * 2,
  },
});

export default styles;
